import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './AsideSticky.css';
import { throttle } from '@cian/newbuilding-utils';
import { clsx } from 'clsx';
import { HEADER_HIDE_ZONE } from '../../constants/elements';
export const AsideSticky = (props: React.PropsWithChildren<{}>): React.JSX.Element => {
  const [isTopSpace, setTopSpace] = React.useState(false);

  const fixHeader = () => {
    const yOffser = window.scrollY;
    if (yOffser > HEADER_HIDE_ZONE) {
      setTopSpace(true);
    } else if (yOffser < HEADER_HIDE_ZONE) {
      setTopSpace(false);
    }
  };

  const onScrollHandler = throttle(50, fixHeader);

  React.useEffect(() => {
    fixHeader();
    window.addEventListener('scroll', onScrollHandler, false);

    return () => {
      window.removeEventListener('scroll', onScrollHandler, false);
    };
  }, [onScrollHandler]);

  return (
    <Responsive desktop>
      <div className={styles['aside']}>
        <div className={clsx(styles['sticky'], isTopSpace && styles['sticky-top-space'])}>{props.children}</div>
      </div>
    </Responsive>
  );
};
